module.exports = __webpack_public_path__ + "static/img/COVER-7.e19d2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-7.png
// module id = kvlV
// module chunks = 31